// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14kkL","rightAdornment":"Header_rightAdornment__19ZtJ"};